// src/features/feedback/services/feedbackVoteService.js
import { apiClient } from '../../../services/api/client';

export class FeedbackVoteService {
  /**
   * Vote on feedback
   */
  async voteOnFeedback(feedbackId) {
    try {
      const response = await apiClient.post(`/api/v1/feedback/votes/${feedbackId}`);
      return response.data;
    } catch (error) {
      throw this.handleVoteError(error);
    }
  }

  /**
   * Remove vote from feedback
   */
  async removeVote(feedbackId) {
    try {
      const response = await apiClient.delete(`/api/v1/feedback/votes/${feedbackId}`);
      return response.data;
    } catch (error) {
      throw this.handleVoteError(error);
    }
  }

  /**
   * Get vote statistics (admin only)
   */
  async getVoteStatistics(feedbackId) {
    try {
      const response = await apiClient.get(`/api/v1/feedback/votes/${feedbackId}/statistics`);
      return response.data;
    } catch (error) {
      throw this.handleVoteError(error);
    }
  }

  /**
   * Handle vote-specific errors
   */
  handleVoteError(error) {
    const errorData = error.response?.data;

    if (errorData?.error_code) {
      switch (errorData.error_code) {
        case 'FEEDBACK_VOTE__ALREADY_EXISTS':
          return new Error('You have already voted on this feedback');
        case 'FEEDBACK_VOTE__NOT_FOUND':
          return new Error('Vote not found');
        case 'FEEDBACK__NOT_FOUND':
          return new Error('Feedback not found');
        default:
          return new Error(errorData.message || 'Vote operation failed');
      }
    }

    return new Error(error.message || 'Network error occurred');
  }
}

export const feedbackVoteService = new FeedbackVoteService();